/* 注册全局组件 */
import Header from "./inc/Header";
import sidebar from "./inc/sidebar";
import Footer from "./inc/footer";
import Login from "./inc/login"
import Bread from "./inc/bread"
// 作家中心
import writelist from "./author/writelist";
import chapterTip from "./author/chapterTip";
// 确认弹窗
import surePop from "./inc/surepop.vue";
/* ======用户 */
import authorbar from "./author/authorbar";
const comments = {
  install: function(Vue) {
    Vue.component("Header", Header);
    Vue.component("Footer", Footer);
    Vue.component("Bread", Bread);
    Vue.component("Login", Login);
    Vue.component("sidebar", sidebar);
    Vue.component("authorbar", authorbar);
    Vue.component("writeList", writelist);
    Vue.component("chapterTip", chapterTip);
    Vue.component("surePop", surePop);
  }
};
export default comments;
